<template>
    <div id="me">
      <van-row >
          <div style="height:200px;background: #66CDAA;display: flex;justify-content: center;align-items: center;">
            <img style="width: 100px;height: 100px;" src="@/assets/user.png" background-size="cover"></img>
          </div>
      </van-row>
      <van-row>
        <van-cell title="绑定云帐号" @click="bindCloud" is-link class="search-icon"></van-cell>
        <van-cell title="版本" is-link value="20221224" class="search-icon"></van-cell>
      </van-row>
      <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item name="keys" icon="home-o" >钥匙</van-tabbar-item>
        <van-tabbar-item name="me" icon="friends-o" class="search-icon">我的</van-tabbar-item>
      </van-tabbar>
    </div>
</template>

<script>
export default {
  data() {
     return {
        active:'me',
     }
   },
   methods: {
     onChange(){
          switch(this.active){
            case 'keys':
            this.$router.push({ path: "ekeyList" });
              break
            case 'me':
            this.$router.push({ path: "me" });
              break  
          }
        },
        bindCloud(){
            window.location='./register.html'
        }
   } 
}
</script>

<style>
.search-icon {
    font-size: 16px;
    line-height: inherit;
  }
.userinfo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.userinfo-avatar {
  width: 108rpx;
  height: 108rpx;
  margin: 7rpx;
  border-radius: 50%;
}
.userinfo-nickname {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/app/me.vue